export default (axios, baseURL) => async () => {
  const url = `/v2/auth/cross-tenant-session`;
  const axiosConfig = {
    method: 'POST',
    baseURL,
    url,
    headers: {
      Authorization: 'interceptor-set-token'
    },
    skipAuthLogout: true
  };
  try {
    const axiosResponse = await axios(axiosConfig);
    return axiosResponse.data;
  } catch (apiErr) {
    if (apiErr.response && apiErr.response.status === 401) {
      return null;
    }
    throw apiErr;
  }
};
